import { useReducer } from "react";
import { initialState } from "./Home.model";
import { HomeReducer } from "./Home.reducers";
import { HomeServices } from "./Home.services";
import { HOME_ACTIONS } from "./Home.actions";
import { changeHeaderToken } from "common/HttpClient/http-client";
import { changeHeaderTokenPAdmin } from "common/HttpClient/http-client-pAdmin";
import { fetchAppActiveCustomers } from "common/Services/ActiveCustomersMaster";

export const useHomePageHooks = () => {
  const [state, dispatch] = useReducer(HomeReducer, initialState);
  const services = HomeServices();
  const actions = HomeActions(dispatch, services);

  return { state, actions };
};

const HomeActions = (dispatch, services) => {
  const actions = {
    getCustomersList: async (onSuccess) => {
      dispatch({
        type: HOME_ACTIONS.LOADING,
        payload: true,
      });
      try {
        const sortedList = await fetchAppActiveCustomers();
        dispatch({
          type: HOME_ACTIONS.CUSTOMERSLIST,
          payload: sortedList,
        });
        if (typeof onSuccess === "function") {
          onSuccess(sortedList);
        }
      } catch {
        dispatch({
          type: HOME_ACTIONS.ERROR,
          payload: "Please try again after some time",
        });
      }
      dispatch({
        type: HOME_ACTIONS.LOADING,
        payload: false,
      });
    },
    searchCustomers: (searchQuery) => {
      dispatch({
        type: HOME_ACTIONS.SEARCHCUSTOMER,
        payload: searchQuery,
      });
    },
    setSlectedCustomer: (customer_info, userId) => {
      const customerCode = customer_info?.customerCode;
      changeHeaderToken(userId, customerCode);
      changeHeaderTokenPAdmin(userId, customerCode);
      const stored = { ...customer_info, customerCode };
      localStorage.setItem("selected_customer", JSON.stringify(stored));
      dispatch({
        type: HOME_ACTIONS.SELECTEDCUSTOMER,
        payload: stored,
      });
    },
  };
  return actions;
};